import React from "react";
import { Helmet } from "react-helmet-async";

const defaultMeta = {
  title: "Brighton Centro de Inglés | The Bridge to Your Future",
  description:
    "Cursos de inglés en Pasto para niños, jóvenes y adultos. Prepárate para IELTS, TOEFL y APTIS con profesores expertos y metodologías comunicativas. ¡Inscríbete hoy!",
  url: "https://brightonenglishcenter.edu.co/",
  image: "https://brightonenglishcenter.edu.co/img/img/toefl-post.webp",
  keywords:
    "cursos de inglés en Pasto, instituto de inglés en Pasto, academia de inglés en Pasto, certificaciones internacionales en Pasto, IELTS en Pasto, TOEFL en Pasto, APTIS en Pasto",
};

export default function Seo({
  title,
  description,
  pathname = "",
  image,
  children,
  noindex = false,
  canonical,
  keywords,
}) {
  const meta = {
    title: title ? `Brighton Centro de Inglés | ${title}` : defaultMeta.title,
    description: description || defaultMeta.description,
    url:
      defaultMeta.url + (pathname.startsWith("/") ? pathname : `${pathname}`),
    image: image || defaultMeta.image,
    canonical: canonical || defaultMeta.url,
    keywords: keywords || defaultMeta.keywords,
  };

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />
      <meta name="keywords" content={meta.keywords} />
      <link rel="canonical" href={meta.canonical} />

      {/* Open Graph */}
      <meta property="og:locale" content="es_CO" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Brighton Centro de Inglés" />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.url} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
      <meta
        property="og:image:alt"
        content={`${defaultMeta.siteName} — Preparación APTIS, OOPT, IELTS y TOEFL`}
      />

      {children}
    </Helmet>
  );
}
